<template>
    <div class="register">
        <div class="login-header">
            <img src="../../assets/imgs/logo.png">
        </div>
        <div class="register-box">
            <p class="title">注册账号</p>
            <el-form ref="ruleForm2" :model="ruleForm2"  :rules="rules" @submit.native.prevent class="submit-box">
                <el-form-item  prop="username">
                    <el-input v-model="ruleForm2.username" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item  prop="tel">
                    <el-input v-model="ruleForm2.tel" placeholder="请输入手机号码"></el-input>
                 </el-form-item>
                 <el-form-item  prop="password">
                    <el-input v-model="ruleForm2.password" placeholder="6-16位密码，区分大小写" type='password' ></el-input>
                </el-form-item>
                <el-form-item  prop="checkPass">
                     <el-input v-model="ruleForm2.checkPass" placeholder="确认密码" type='password'></el-input>
                </el-form-item>
                <el-form-item class='submits' style='border: 0;'>
                    <el-button :plain="true" @click="onSubmit('ruleForm2')">注册</el-button>
                </el-form-item>
            </el-form>
            <p class="has" @click='goLogin()'>使用已有帐户登录</p>
        </div>
        <div class="workName">
            <p>
                <span>帮助</span>
                <span>隐私</span>
                <span>条款</span>
            </p>
            <p>技术支持@金马节能科技（深圳）有限公司</p>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            ruleForm2:{
                username:'',
                password:'',
                tel:'',
                checkPass:''
            },
            rules:{
                username: [
                    { required: true, message: '请输入用户名', trigger: 'change' },
                    
                ],
                password:[{required: true, message: '请输入密码',},
                {validator:(rule, value, callback)=>{
                    if (value === '') {
                    callback(new Error('请输入密码'));
                    } else {
                        if (this.ruleForm2.checkPass !== '') {
                            this.$refs.ruleForm2.validateField('checkPass');
                        }
                        callback();
                    }
                }}, {trigger: 'blur'}],
                tel:[{required: true, message: '请输入手机号', trigger: 'change'},{
                    validator:(rule, value, callback)=>{
                        if(value.length === 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value)){
                            callback();
                        }else{
                            callback(new Error('手机格式错误'));
                        }
                    },
                    trigger: 'blur'
                }],
                checkPass:[{required: true, message: '请输入密码', trigger: 'blur'},{
                    validator:(rule, value, callback)=>{
                        if (value === '') {
                            callback(new Error('请再次输入密码'));
                        }else if (value !== this.ruleForm2.password) {
                            callback(new Error('两次输入密码不一致!'));
                        }else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }],
            },
        }
    },
    methods:{
        onSubmit(formName) {
            var vm=this;
				// console.log(vm.ruleForm2)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    vm.$http.post('/api/console/register',{
                        username:vm.ruleForm2.username,
                        mobile:vm.ruleForm2.tel,
                        password:vm.ruleForm2.password
                    }).then((res)=>{
                        if(res.code==0){
                            this.$router.push({path:'/baseData'})
                        }
                    })
                }else{
                    vm.$message.error({
                        message:'请将数据填写完整',
                        center: false
                    });
                }
            })
        },
        goLogin(){
            this.$router.push({path:'/login'})
        }
    }
}
</script>
<style lang="less">
.register{
        display: flex;
        flex-direction: column;
        height: 98%;
        background:rgba(245,246,247,1);
        .login-header{
            height:48px !important;
            background:rgba(38,38,38,1);
            box-sizing:border-box;
            padding-left:30px;
            margin-bottom:4%;
            width:100%;
            line-height:48px;
            min-width:1200px;
            img{
              position: relative;
              top:12px;
              
            }
        }
        .register-box{
            /* flex:1; */
            width: 1200px;
            margin:0 auto;
            background:rgba(255,255,255,1);
            box-shadow:0px 4px 6px 0px rgba(0,2,31,0.1);
            box-sizing: border-box;
            padding: 60px 390px;
     
            .title{
                text-align: center;
                font-size:30px;
                font-family:SourceHanSansCN-Light;
                font-weight:300;
                color:rgba(0,0,0,1);
            }
            .has{
                text-align: right;
                font-size:14px;
                font-family:SourceHanSansCN-Light;
                font-weight:300;
                color:rgba(0,151,238,1);
                cursor: pointer;
            }
            .submit-box{
                margin-top:50px;
                /* .el-input{
                    margin-bottom: 27px;
                } */
                .submits{
                    width: 100%;
                    margin-top: 60px;
                    .el-button{
                        width: 100%;
                        background:rgba(0,151,238,1);
                        color:rgba(255,255,255,1);
                    }
                }
            }
        }
        .workName{
			height: 88px;
			margin-top: 4%;
			p{
				height: 44px;
				line-height:44px;
				text-align:center;
				font-size:12px;
				font-family:SourceHanSansCN-Light;
				font-weight:300;
				color:rgba(153,153,153,1);
			}
			p:first-child{
				border-bottom: 1px solid rgba(178,178,178,1);
				span{
					margin-right:42px;
					font-size:14px;
					font-family:SourceHanSansCN-Light;
					font-weight:300;
					color:rgba(143,143,143,1);
				}
				span:last-child{
					margin-right: 10px;
				}
			}
		}
}
</style>


// WEBPACK FOOTER //
// src/views/login/register.vue